export function countSelectedElements(layers) {
  let totalElements = 0;

  layers.forEach((layer) => {
    ["text", "image"].forEach((type) => {
      if (layer["allow_" + type]) {
        totalElements += layer[type + "_elements"].reduce((total, element) => {
          return element.is_selected ? total + 1 : total;
        }, 0);
      }
    });
  });

  return totalElements;
}
